import { NetworkType } from '@elrondnetwork/dapp-core'

export const decimals = 4
export const denomination = 18
export const gasPerDataByte = 1500
export const timeout = 10000 // 10 sec
export const gasLimit = 50000

export const walletConnectBridgeAddresses: string[] = [
    'https://bridge.walletconnect.org',
]
export const walletConnectBridge: string =
    walletConnectBridgeAddresses[
        Math.floor(Math.random() * walletConnectBridgeAddresses.length)
    ]

export const walletConnectDeepLink =
    'https://maiar.page.link/?apn=com.elrond.maiar.wallet&isi=1519405832&ibi=com.elrond.maiar.wallet&link=https://maiar.com/'

export const dAppName = 'Natural Born Degenz'

export const network: NetworkType & {
    graphQlAddress: string
} = {
    id: 'mainnet',
    name: 'Mainnet',
    egldLabel: 'EGLD',
    walletAddress: 'https://wallet.elrond.com',
    apiAddress: 'https://api.elrond.com',
    gatewayAddress: 'https://gateway.elrond.com',
    explorerAddress: 'http://explorer.elrond.com',
    graphQlAddress: 'https://devnet-exchange-graph.elrond.com/graphql',
    // walletAddress: "https://devnet-wallet.elrond.com",
    // apiAddress: "https://devnet-api.elrond.com",
    // gatewayAddress: "https://devnet-gateway.elrond.com",
    // explorerAddress: "http://devnet-explorer.elrond.com/",
    // graphQlAddress: 'https://devnet-exchange-graph.elrond.com/graphql'
}
export const smartContractAddress =
    'erd1qqqqqqqqqqqqqpgq0mzqmk4qaae3zy7q9rv8fme2qr87j55fyl5slgdxgf'
export const nftStakingSCAddress =
    'erd1qqqqqqqqqqqqqpgq3z36wc2tnjlmatu5cylxrjcd39j02wztyl5samaxqg'
export const ngmiStakingSCAddress =
    'erd1qqqqqqqqqqqqqpgqw9r8f74wrsyzrvwrxxde380uthjppdlayl5s0w03ae'
export const headlockSCAddress =
    'erd1qqqqqqqqqqqqqpgqc5tvhf4zgl0ha9fufsffn98em2tc3kx5yl5s6f093t'
